// // src/UploadMergedJson.js
// import React, { useState } from "react";
// import { db } from "./firebase";
// import { collection, doc, setDoc } from "firebase/firestore";

// const UploadMergedJson = () => {
//   const [fileName, setFileName] = useState("");
//   const [rawJson, setRawJson] = useState("");
//   const [data, setData] = useState(null); // merged object
//   const [status, setStatus] = useState("");
//   const [isUploading, setIsUploading] = useState(false);

//   // "HTML/CSS" -> "html-css", "JAVASCRIPT" -> "javascript"
//   const slugify = (str = "") =>
//     String(str)
//       .trim()
//       .toLowerCase()
//       .replace(/[^a-z0-9]+/g, "-")
//       .replace(/(^-|-$)/g, "");

//   const handleFileChange = (e) => {
//     const file = e.target.files?.[0];
//     if (!file) return;

//     setFileName(file.name);
//     setStatus("");
//     setData(null);
//     setRawJson("");

//     const reader = new FileReader();
//     reader.onload = (event) => {
//       try {
//         const text = event.target.result || "";
//         setRawJson(text);

//         const parsed = JSON.parse(text);

//         if (!parsed || typeof parsed !== "object" || Array.isArray(parsed)) {
//           setStatus("JSON must be an object like { HTML: [ {question, answer}, ... ], CSS: [...] }");
//           return;
//         }

//         setData(parsed);
//         setStatus(`Loaded ${Object.keys(parsed).length} topic(s) from file.`);
//       } catch (err) {
//         console.error("JSON parse error:", err);
//         setStatus("Error parsing JSON. Please check the file format.");
//       }
//     };

//     reader.readAsText(file);
//   };

//  const handleUpload = async () => {
//   if (!data || typeof data !== "object") {
//     setStatus("No data to upload. Please select a valid JSON file first.");
//     return;
//   }

//   setIsUploading(true);
//   setStatus("Uploading to Firebase…");

//   try {
//     const topics = Object.keys(data); // e.g. ["HTML", "CSS", "JAVASCRIPT", ...]

//     for (const topic of topics) {
//       const qaArray = data[topic];

//       if (!Array.isArray(qaArray) || qaArray.length === 0) {
//         console.warn("Skipping topic without questions:", topic);
//         continue;
//       }

//       const topicSlug = slugify(topic); // "HTML" -> "html", "JavaScript" -> "javascript"

//       // 1. Document: interview/{topicSlug}
//       const topicRef = doc(collection(db, "interview"), topicSlug);

//       // Ensure every QA item is clean
//       const cleanedQuestions = qaArray.map((qa, index) => ({
//         question: (qa.question || "").toString().trim(),
//         answer: (qa.answer || "").toString().trim(),
//         order: index
//       }));

//       // 2. Save *everything* into ONE document
//       await setDoc(
//         topicRef,
//         {
//           title: topic,
//           totalQuestions: cleanedQuestions.length,
//           updatedAt: new Date().toISOString(),
//           questions: cleanedQuestions
//         },
//         { merge: true }
//       );
//     }

//     setStatus("Upload complete! Data saved as interview/{topic} documents.");
//   } catch (err) {
//     console.error("Error uploading to Firebase:", err);
//     setStatus("Error uploading to Firebase. Check console for details.");
//   } finally {
//     setIsUploading(false);
//   }
// };


// //   const handleUpload = async () => {
// //     if (!data || typeof data !== "object") {
// //       setStatus("No data to upload. Please select a valid JSON file first.");
// //       return;
// //     }

// //     setIsUploading(true);
// //     setStatus("Uploading to Firebase…");

// //     try {
// //       const topics = Object.keys(data);

// //       for (const topic of topics) {
// //         const qaArray = data[topic];

// //         if (!Array.isArray(qaArray) || qaArray.length === 0) {
// //           console.warn("Skipping topic without questions:", topic);
// //           continue;
// //         }

// //         const topicSlug = slugify(topic); // HTML -> html, CSS -> css

// //         // Main doc: interview/{topicSlug}
// //         const interviewCollection = collection(db, "interview");
// //         const topicDocRef = doc(interviewCollection, topicSlug);

// //         await setDoc(
// //           topicDocRef,
// //           {
// //             title: topic,
// //             totalQuestions: qaArray.length,
// //             updatedAt: new Date().toISOString(),
// //           },
// //           { merge: true }
// //         );

// //         // Subcollection: interview/{topicSlug}/{topicSlug}
// //         const questionsCollection = collection(topicDocRef, topicSlug);

// //         const questionPromises = qaArray.map((qa, index) => {
// //           const questionText = (qa.question || "").toString();
// //           const answerText = (qa.answer || "").toString();

// //           const questionId =
// //             slugify(questionText) || `q_${index}_${Date.now().toString(36)}`;

// //           const questionDocRef = doc(questionsCollection, questionId);

// //           const payload = {
// //             question: questionText,
// //             answer: answerText,
// //             order: index,
// //           };

// //           return setDoc(questionDocRef, payload, { merge: true });
// //         });

// //         await Promise.all(questionPromises);
// //       }

// //       setStatus("Upload complete: data saved under interview/{topic}/{topic}.");
// //     } catch (err) {
// //       console.error("Error uploading to Firebase:", err);
// //       setStatus("Error uploading to Firebase. Check console for details.");
// //     } finally {
// //       setIsUploading(false);
// //     }
// //   };

//   return (
//     <div className="upload-json">
//       <h2>Upload Interview Questions JSON → Firebase</h2>

//       <div className="upload-card">
//         <div className="form-group">
//           <label>Choose merged JSON file</label>
//           <input
//             type="file"
//             accept=".json,application/json"
//             onChange={handleFileChange}
//           />
//           {fileName && <p className="file-name">Selected: {fileName}</p>}
//         </div>

//         {rawJson && (
//           <div className="preview-group">
//             <label>Preview (first ~400 chars)</label>
//             <pre className="preview-box">
//               {rawJson.slice(0, 400)}
//               {rawJson.length > 400 ? " ..." : ""}
//             </pre>
//           </div>
//         )}

//         {data && (
//           <p className="summary">
//             Topics found:&nbsp;
//             <strong>{Object.keys(data).length}</strong>
//           </p>
//         )}

//         <button
//           type="button"
//           className="primary-btn"
//           onClick={handleUpload}
//           disabled={!data || isUploading}
//         >
//           {isUploading ? "Uploading…" : "Upload to Firebase"}
//         </button>

//         {status && <p className="status-text">{status}</p>}
//       </div>

//       <style>{`
//         .upload-json {
//           max-width: 800px;
//           margin: 1rem auto;
//           padding: 1rem;
//           border-radius: 8px;
//           border: 1px solid #ddd;
//           background: #fafafa;
//         }
//         .upload-card {
//           display: flex;
//           flex-direction: column;
//           gap: 0.75rem;
//         }
//         .form-group {
//           display: flex;
//           flex-direction: column;
//           gap: 0.25rem;
//         }
//         .file-name {
//           font-size: 0.9rem;
//           color: #555;
//         }
//         .preview-group {
//           display: flex;
//           flex-direction: column;
//           gap: 0.25rem;
//         }
//         .preview-box {
//           max-height: 200px;
//           overflow: auto;
//           background: #111;
//           color: #0f0;
//           padding: 0.5rem;
//           border-radius: 4px;
//           font-size: 0.8rem;
//         }
//         .summary {
//           font-size: 0.95rem;
//         }
//         .primary-btn {
//           padding: 0.5rem 1rem;
//           border-radius: 4px;
//           border: none;
//           cursor: pointer;
//           background: #0d6efd;
//           color: white;
//           font-weight: 600;
//         }
//         .primary-btn:disabled {
//           opacity: 0.6;
//           cursor: not-allowed;
//         }
//         .status-text {
//           margin-top: 0.5rem;
//           font-size: 0.9rem;
//         }
//       `}</style>
//     </div>
//   );
// };

// export default UploadMergedJson;

// src/UploadSubjectJson.js
import React, { useState } from "react";
import { db } from "./firebase";
import { collection, doc, setDoc } from "firebase/firestore";

// simple slugify helper
const slugify = (str) =>
  String(str || "")
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "") || "untitled";

const UploadSubjectJson = () => {
  const [rawJson, setRawJson] = useState(null);
  const [status, setStatus] = useState("");
  const [isUploading, setIsUploading] = useState(false);

  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (event) => {
      try {
        const text = event.target?.result;
        const parsed = JSON.parse(text);
        setRawJson(parsed);
        setStatus("JSON file loaded. Ready to upload.");
      } catch (err) {
        console.error("Invalid JSON:", err);
        setStatus("Error: Invalid JSON file.");
        setRawJson(null);
      }
    };
    reader.readAsText(file);
  };

  const handleUpload = async () => {
    if (!rawJson || typeof rawJson !== "object") {
      setStatus("No data to upload. Please select a valid JSON file first.");
      return;
    }

    setIsUploading(true);
    setStatus("Uploading to Firebase…");

    try {
      // rawJson is: { "HTML": { description, topics: [...] }, "CSS": { ... }, ... }
      const subjectNames = Object.keys(rawJson); // e.g. ["Introduction", "HTML", "CSS", "JavaScript", ...]

      for (const subjectName of subjectNames) {
        const section = rawJson[subjectName];

        // Skip if no topics array
        if (!section || !Array.isArray(section.topics)) {
          console.warn("Skipping section without topics:", subjectName);
          continue;
        }

        const description = (section.description || "").toString().trim();
        const topicsArray = section.topics;

        const subjectSlug = slugify(subjectName); // "HTML" -> "html", "JavaScript" -> "javascript"

        // Build questions array to store in doc
        const questions = topicsArray.map((item, index) => {
          const topic = (item.topic || "").toString().trim();
          const questionText =
            (item.question || item.topic || "").toString().trim();
          const answerText = (item.answer || "").toString().trim();
          const usecaseText = (item.usecase || "").toString().trim();
          const scenarioText =
            (item.scanario || item.scenario || "").toString().trim();

          return {
            id: slugify(questionText || topic || `q-${index}`),
            topic,
            question: questionText,
            answer: answerText,
            order: index,
            usecase: usecaseText,
            scenario: scenarioText,
          };
        });

        // Firestore: interview/{subjectSlug}
        const interviewCollection = collection(db, "interview");
        const subjectDocRef = doc(interviewCollection, subjectSlug);

        await setDoc(
          subjectDocRef,
          {
            title: subjectName,
            description,
            totalQuestions: questions.length,
            updatedAt: new Date().toISOString(),
            questions, // array of Q&A under this subject
          },
          { merge: true }
        );
      }

      setStatus("Upload complete! Data saved as interview/{subject} documents.");
    } catch (err) {
      console.error("Error uploading to Firebase:", err);
      setStatus("Error uploading to Firebase. Check console for details.");
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <div style={{ padding: "1rem", maxWidth: 600 }}>
      <h2>Upload Subject-wise JSON to Firestore</h2>

      <input type="file" accept=".json,application/json" onChange={handleFileChange} />

      <div style={{ marginTop: "1rem" }}>
        <button onClick={handleUpload} disabled={!rawJson || isUploading}>
          {isUploading ? "Uploading…" : "Upload to Firebase"}
        </button>
      </div>

      {status && <p style={{ marginTop: "1rem" }}>{status}</p>}
    </div>
  );
};

export default UploadSubjectJson;
